import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Columns.es.js";
const m = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
m.displayName = "ColumnsIcon";
const c = m;
export {
  c as Columns,
  m as ColumnsIcon
};
